<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="设备编号" prop="device" >
        <a-input v-model="form.device" placeholder="请输入设备编号" />
      </a-form-model-item>
      <a-form-model-item label="MAC地址" prop="mac" >
        <a-input v-model="form.mac" placeholder="请输入MAC地址" />
      </a-form-model-item>
      <a-form-model-item label="经销商名称" prop="name" >
        <a-input v-model="form.name" placeholder="请输入经销商名称" />
      </a-form-model-item>
      <a-form-model-item label="经销商手机号" prop="mobile" >
        <a-input v-model="form.mobile" placeholder="请输入经销商手机号" />
      </a-form-model-item>
<!--      <a-form-model-item label="是否激活 " prop="activate" >-->
<!--        <a-radio-group name="radioGroup" :default-value="0" v-model="form.activate">-->
<!--          <a-radio :value=0>未激活</a-radio>-->
<!--          <a-radio :value=1>已激活</a-radio>-->
<!--        </a-radio-group>-->
<!--      </a-form-model-item>-->

      <a-form-model-item label="备注" prop="remark" >
        <a-input v-model="form.remark" placeholder="请输入内容" type="textarea" allow-clear />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getDistributor, addDistributor, updateDistributor } from '@/api/distributor/distributor'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,

        device: null,

        mac: null,

        name: null,

        mobile: null,

        activate: null,

        userId: null,

        deviceVersionId: null,

        createTime: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        device: [
          { required: true, message: '设备编号不能为空', trigger: 'blur' }
        ],
        mac: [
          { required: true, message: 'MAC地址不能为空', trigger: 'blur' }
        ],
        name: [
          { required: true, message: '经销商名称不能为空', trigger: 'blur' }
        ],
        mobile: [
          { required: true, message: '经销商手机号不能为空', trigger: 'blur' }
        ],
        activate: [
          { required: true, message: '是否激活 0-未激活 1-已激活不能为空', trigger: 'blur' }
        ],
        userId: [
          { required: true, message: '绑定用户id,外键{zb_user.id}不能为空', trigger: 'blur' }
        ],
        deviceVersionId: [
          { required: true, message: '设备版本id,外键{zb_device_version.id}不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        device: null,
        mac: null,
        name: null,
        mobile: null,
        activate: null,
        userId: null,
        deviceVersionId: null,
        createTime: null,
        remark: null,
      }
      this.$nextTick(() => {
        if(this.$refs.form){
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getDistributor({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateDistributor(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addDistributor(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
